import React from "react";

const AddPackages = () => {
  return (
    <>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 19 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M.75 12.75h17.5V19A3.25 3.25 0 0 1 15 22.25H4A3.25 3.25 0 0 1 .75 19v-6.25Z"
          stroke="#000"
          strokeWidth={1.5}
        />
        <path
          d="M18.25 13.25H.75V11A3.25 3.25 0 0 1 4 7.75h11A3.25 3.25 0 0 1 18.25 11v2.25Z"
          stroke="#000"
          strokeWidth={1.5}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.176 5.3c-.508-1.676.086-3.59 1.752-4.157a2.725 2.725 0 0 1 2.573.456 2.745 2.745 0 0 1 2.567-.456c1.667.567 2.264 2.481 1.757 4.157C13.033 7.955 9.5 10 9.5 10S5.994 7.986 5.176 5.3Z"
          stroke="#130F26"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path stroke="#000" strokeLinecap="round" d="M7.5 17.5h4M9.5 15.5v4" />
      </svg>
    </>
  );
};

export default AddPackages;
